export default __webpack_public_path__ + "static/media/carousel1.8b77cb40.jpg";